import { wenji } from 'libraries/interfaces/IWenji';
import { IHeader } from "libraries/service/resource/IHeader";

export class HotelApiHeaderParameters {

    public static headerParameters: IHeader = {
        template: 'Full',
        language: 'FR',
        nbrecord: '100',
        target: wenji && wenji.ui && wenji.ui.target,
    };
}
